import { FC } from "react";
import { DepartmentProgress as SharedDepartmentProgress } from "../../../../components/lifecycle/departmentProgress";
import {
  Department,
  getStatus
} from "../../../../components/lifecycle/departmentProgress/utils";
import { canAccessLifecycle } from "../../../../auth/permissions";
import { useIsEntityVp } from "../../../../auth/entityVpContext";
import { useIsEntityMerger } from "../../../../auth/entityMergerContext";
import { LIFECYCLE_LABELS } from "../../../../auth/roles";
import { useRoles } from "../../../../auth/useRoles";

type Props = {
  marketAccessProgress?: string | null;
  complianceProgress?: string | null;
  legalProgress?: string | null;
  riskProgress?: string | null;
  creditRiskProgress?: string | null;
  treasuryProgress?: string | null;
  financeProgress?: string | null;
  techProgress?: string | null;
  complianceAlert?: boolean;
  legalAlert?: boolean;
  riskAlert?: boolean;
};

export const DepartmentProgress: FC<Props> = ({
  marketAccessProgress,
  complianceProgress,
  legalProgress,
  riskProgress,
  creditRiskProgress,
  treasuryProgress,
  financeProgress,
  techProgress
}) => {
  const roles = useRoles();
  const isEntityVp = useIsEntityVp();
  const isMerger = useIsEntityMerger();

  const allDepartments: Department[] = [
    {
      key: "marketaccess",
      label: LIFECYCLE_LABELS.marketaccess,
      status: getStatus(marketAccessProgress)
    },
    {
      key: "compliance",
      label: LIFECYCLE_LABELS.compliance,
      status: getStatus(complianceProgress)
    },
    {
      key: "creditrisk",
      label: LIFECYCLE_LABELS.creditrisk,
      status: getStatus(creditRiskProgress)
    },
    {
      key: "legal",
      label: LIFECYCLE_LABELS.legal,
      status: getStatus(legalProgress)
    },
    {
      key: "risk",
      label: LIFECYCLE_LABELS.risk,
      status: getStatus(riskProgress)
    },

    {
      key: "treasury",
      label: LIFECYCLE_LABELS.treasury,
      status: getStatus(treasuryProgress)
    },
    {
      key: "finance",
      label: LIFECYCLE_LABELS.finance,
      status: getStatus(financeProgress)
    },
    {
      key: "tech",
      label: LIFECYCLE_LABELS.tech,
      status: getStatus(techProgress)
    }
  ];
  // A merger has no Market Access lifecycle to work (its answers came in on the create form).
  const departments = isMerger
    ? allDepartments.filter((d) => d.key !== "marketaccess")
    : allDepartments;

  return (
    <SharedDepartmentProgress
      departments={departments}
      canAccess={(lifecycle) =>
        canAccessLifecycle(roles, lifecycle, isEntityVp, isMerger)
      }
      minWidth={800}
    />
  );
};
